import { defineMessages } from 'react-intl';

export const signupMessages = defineMessages({
	invalid_configuration: {
		id: 'signup.invalid_configuration',
		defaultMessage: 'Invalid Signup configuration',
		description:
			'This text appears when a user reach signup page even if this is not enabled/had configured',
	},
	header_title: {
		id: 'signup.header.signup.title',
		defaultMessage: 'Ready to sign up?',
		description: 'Title text placed in header of the chat frame',
	},
	header_description: {
		id: 'signup.header.signup.description',
		defaultMessage: 'Fill in the form',
		description:
			'Description text placed in header of the chat frame, above the title',
	},
});
